import { useCallback, useEffect, useRef, useState } from 'react';
import { ELEMENT_ID } from '@/core/constants/common/element-constants';
import { ButtonType } from 'devextreme-react/common';
import Form from 'devextreme-react/form';
import { Col, Row } from 'react-bootstrap';

import { t } from 'i18next';
import { IResourceDefinition } from '@/core/interfaces/admin/usestate-interfaces';
import { languageService } from '@/core/services/language-service';
import { resourceService } from '@/projects/admin/services/resource-service';
import { applicationService } from '@/projects/admin/services/application-service';
import DataSource from 'devextreme/data/data_source';
import { useNavigate, useParams } from 'react-router-dom';
import { Required } from '@/core/helper/validation-rule-helper';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';
import CustomStore from 'devextreme/data/custom_store';

const store = new DataSource({});
const ResourceDefinition = (props: any) => {
  const params = useParams()
  const resourceId = params.id;
  const navigate = useNavigate();
  const [resource, setResource] = useState<IResourceDefinition>({ id: '', code: '', applicationId: '', translates: [] });
  const [languages, setLanguages] = useState([{ id: '', description: '', flagUrl: '', order: null, }]);



  const handleSubmit = useCallback(async (): Promise<void> => {
    return new Promise(async (resolve, reject) => {
      try {
        const resourceForm = formRef.current.props.formData;
        resourceForm.id = resourceId;
        const elements = document.getElementsByClassName("languages");

        if (resourceForm.id) {
          await resourceService.updateResource(null, resourceForm);
        } else {
          Array.from(elements).map((item, index) => {
            const id = item.className.split(" ")[0];
            resourceForm.translates[index].languageId = id;
          });
          await resourceService.createResource(resourceForm);
        }
        store.reload();
        resolve();
      } catch (error) {
        reject(error)
      }

    })
  }, []);


  const formRef: any = useRef<Form>();
  useEffect(() => {
    (async function () {
      if (typeof resourceId !== "undefined") {
        const getResource = await resourceService.getResource(resourceId);
        const data = getResource.data;
        const getResourceTranslate = await resourceService.getResourceTranslate(resourceId);
        const resourceTranslateData = getResourceTranslate.data;
        setResource({
          id: data.id,
          code: data.code,
          applicationId: data.applicationId,
          translates: resourceTranslateData
        });
      }
    })();
  }, [])
  useEffect(() => {
    const fetchLanguages = async () => {
      const languages = await languageService.getLanguages({});
      setLanguages(languages.data);

    };
    fetchLanguages();

  }, [])

  const [applications] = useState(new CustomStore({
    key: 'id',
    load: applicationService.lookupApplication,
    byKey: async (key, loadOptions: any) => {
      var returnObject = null;
      if (key) {
        loadOptions.filter = ["id", "=", key];
        const objectsByID = (await applicationService.lookupApplication(loadOptions))
        returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
      }
      return returnObject
    },
    useDefaultSearch: true,
  }));

  const applicationsEditorOptions = {
    inputAttr: { [ELEMENT_ID]: 'applications' },
    dataSource: applications,
    displayExpr: 'name',
    valueExpr: 'id',
    placeholder: t('select_application'),
  };
  const codeEditorOptions = {
    inputAttr: { [ELEMENT_ID]: 'code' },
  };

  return (
    <FormWrapper
      onSubmit={handleSubmit}
      formRef={formRef}
      formData={resource}
      backButtonNavigationPath='/admin/resource-list'
      buttonGroups=
      {[
        { buttonOptions: BUTTON_CONSTANTS.SaveBtn }]
      }
      simpleItemGroups={[
        {
          caption: resource.id == '' ? t('new_resource') : t('edit_resource'),
          useColCountByScreen: true,
          items: [
            {
              dataField: 'applicationId',
              label: 'application',
              editorType: 'dxSelectBox',
              editorOptions: applicationsEditorOptions,
              isRequired: true,
              requiredMessage: Required(t('application'))
            },
            {
              dataField: 'code',
              label: 'code',
              editorOptions: codeEditorOptions,
              isRequired: true,
              requiredMessage: Required(t('code'))
            },
            ...languages.map((language, index) => ({
              dataField: `translates[${index}].description`,
              label: `${language.description} ${t('definition')}`,
              isRequired: true,
              requiredMessage: Required(`${language.description} ${t('definition')}`)
            }))
          ]
        }
      ]}
    />
  )
}


export default ResourceDefinition;